import type { IconData } from '@stacksjs/iconify-core'

export const handPointRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M273.919 472h-159.7a24 24 0 0 1-12.349-3.421L16 417.059V272.891L263.244 49.574a24 24 0 0 1 34.149 2.007A90.41 90.41 0 0 1 286.6 181.088L264 199.582V224h180a52 52 0 0 1 0 104H332.162l-35.119 126.423A24.07 24.07 0 0 1 273.919 472m-157.487-32h151.406l40-144H444a20 20 0 0 0 0-40H232v-71.582l34.34-28.1a58.437 58.437 0 0 0 11.91-77.18L48 287.109v111.832ZM284.693 73.321l-.023.02z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default handPointRight
